/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-28 15:53:54
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-01-11 00:17:15
 * @FilePath: \baishu_react_ui\src\utils\WidgetFilter\AddressWidgetFilter.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import WidgetFilter from ".";

import negate from "lodash/negate";

import { BsyUtils } from "../Utils";

export default class SignatureWidgetFilter extends WidgetFilter {
    empty  () {
        return function(t) {
            return BsyUtils.isObjectEmpty(t)
        }
    } 
    notEmpty  () {
        return negate(this.empty())
    }
}
